mutation PublishChoreographFeed($jobId: ID!, $uniqueIdsList: [String!]!) {
    publishChoreographFeed(jobId: $jobId, uniqueIdsList: $uniqueIdsList)
}
